import { Auth } from '@aws-amplify/auth';
import { handleResponse, handleError } from './api-utils';
import { apiConstants } from './api-constants';

export function getSSOVerifyEmailFormData() {
    return fetch(apiConstants.loadVerifyEmailFormDataUrl)
        .then(handleResponse)
        .catch(handleError);
}

export function verifyEmail(verificationCode) {
    return Auth.verifyCurrentUserAttributeSubmit(apiConstants.emailAttributeName, verificationCode);
}
